export default {
  dots: "dots",
  rounded: "rounded",
  square: "square"
} as DotTypes;
